/**
 * Track a page visit for analytics
 * @param {string} pageType - Type of page (home, service, offer, other)
 * @param {string} pagePath - Path of the page
 * @param {string} pageTitle - Title of the page
 * @param {number} relatedId - ID of related service/offer (optional)
 * @param {string} relatedType - Type of related item (service, offer) (optional)
 */
export const trackPageVisit = async (
  pageType,
  pagePath,
  pageTitle,
  relatedId = null,
  relatedType = null
) => {
  try {
    const apiUrl =
      process.env.REACT_APP_API_URL || "https://silver.khalilalhraky.com/api";

    const response = await fetch(`${apiUrl}/analytics/track`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        page_type: pageType,
        page_path: pagePath,
        page_title: pageTitle,
        related_id: relatedId,
        related_type: relatedType,
      }),
    });

    if (response.ok) {
      const result = await response.json();
      console.log("Analytics tracked successfully:", {
        pageType,
        pagePath,
        pageTitle,
        result,
      });
    } else {
      console.warn(
        "Analytics tracking failed:",
        response.status,
        response.statusText
      );
    }
  } catch (error) {
    console.warn("Analytics tracking failed:", error);
    // Don't throw error to avoid breaking the user experience
  }
};

/**
 * Track home page visit
 */
export const trackHomePage = () => {
  trackPageVisit("home", "/", "Homepage");
};

/**
 * Track service page visit
 */
export const trackServicePage = (serviceId, serviceTitle) => {
  trackPageVisit(
    "service",
    `/service/${serviceId}`,
    serviceTitle,
    serviceId,
    "service"
  );
};

/**
 * Track offer page visit
 */
export const trackOfferPage = (offerId, offerTitle) => {
  trackPageVisit("offer", `/offer/${offerId}`, offerTitle, offerId, "offer");
};

/**
 * Track services list page visit
 */
export const trackServicesPage = () => {
  trackPageVisit("other", "/services", "Services");
};

/**
 * Track offers list page visit
 */
export const trackOffersPage = () => {
  trackPageVisit("other", "/offers", "Offers");
};

/**
 * Track other page visits
 */
export const trackOtherPage = (path, title) => {
  trackPageVisit("other", path, title);
};
